const inbox = {
  statuses: {
    pending: "بانتظار المراجعة",
    approved: "تمت الموافقة",
    posted: "تم النشر",
    archived: "مؤرشف",
  },
  original: {
    title: "المنشور الأصلي",
    open: "فتح",
    openOriginal: "فتح الأصل",
    mediaOnly: "يحتوي منشور تيليجرام هذا على وسائط دون تعليق نصي.",
    attachmentAlt: "مرفق منشور تيليجرام",
    summary: "ملخص المحتوى الأصلي",
    characters_zero: "لا توجد أحرف",
    characters_one: "حرف واحد",
    characters_two: "حرفان",
    characters_few: "{{formattedCount}} أحرف",
    characters_many: "{{formattedCount}} حرفًا",
    characters_other: "{{formattedCount}} حرف",
    mediaAttached: "وسائط مرفقة",
  },
  preview: {
    title: "معاينة تيليجرام",
    empty: "ستظهر رسالة تيليجرام المنسقة هنا.",
    label: "معاينة",
    source: "المصدر: @{{channel}}",
  },
  ai: {
    toolkit: "أدوات تنسيق المحتوى بالذكاء الاصطناعي",
    generating: "جارٍ الإنشاء",
    description: "تعمل عبر الذكاء الاصطناعي على الخادم. استخدم هذه الإجراءات أثناء المراجعة فقط لتحرير المنشورات.",
    draftReady: "مسودة الذكاء الاصطناعي جاهزة",
    suggestionDescription: "راجع اقتراح «{{action}}» قبل تطبيقه.",
    before: "قبل",
    after: "بعد",
    dismiss: "تجاهل",
    apply: "تطبيق",
    actions: {
      rephrase: "إعادة الصياغة",
      summarize: "تلخيص",
      translate: "ترجمة",
      hashtags: "وسوم",
    },
    tone: "الأسلوب",
    language: "اللغة",
    tones: {
      professional: "احترافي",
      casual: "غير رسمي",
      viral: "جذاب وقابل للانتشار",
      news: "أخبار تحليلية",
      bullets: "ملخص بنقاط",
    },
    languages: {
      english: "الإنجليزية",
      spanish: "الإسبانية",
      russian: "الروسية",
      french: "الفرنسية",
      german: "الألمانية",
      chinese: "الصينية",
      arabic: "العربية",
      persian: "الفارسية",
    },
  },
  editor: {
    title: "النسخة المنسقة",
    unsaved: "تغييرات غير محفوظة",
    saved: "تم حفظ المسودة",
    copied: "تم النسخ",
    copy: "نسخ",
    saveDraft: "حفظ المسودة",
  },
  feedback: {
    draftSaved: "تم حفظ المسودة.",
    approved: "تمت الموافقة على المنشور ونقله إلى قائمة المنشورات الموافق عليها.",
    approveBeforePublishing: "وافق على المنشور قبل نشره.",
    destinationRequired: "قم بإعداد وجهة تيليجرام وتفعيلها قبل النشر.",
    publishSuccess: "تم النشر بنجاح إلى وجهات تيليجرام المحددة.",
    publishFailed: "فشل النشر. راجع خطأ الوجهة ثم حاول مرة أخرى.",
    aiCurationError: "تعذر على الذكاء الاصطناعي معالجة المنشور. تحقق من إعدادات المزود ثم حاول مرة أخرى.",
    aiConnectionError: "تعذر الاتصال بمزود الذكاء الاصطناعي المُعد. حاول مرة أخرى.",
    suggestionApplied: "تم تطبيق اقتراح الذكاء الاصطناعي. احفظ المنشور أو وافق عليه عندما يصبح جاهزًا.",
  },
  destinations: {
    selected_zero: "لم يتم تحديد أي وجهة",
    selected_one: "تم تحديد وجهة واحدة",
    selected_two: "تم تحديد وجهتين",
    selected_few: "تم تحديد {{formattedCount}} وجهات",
    selected_many: "تم تحديد {{formattedCount}} وجهة",
    selected_other: "تم تحديد {{formattedCount}} وجهة",
    noneEnabled: "لا توجد وجهات تيليجرام مفعلة",
    publishingTo_zero: "لا توجد وجهات للنشر",
    publishingTo_one: "النشر إلى وجهة واحدة",
    publishingTo_two: "النشر إلى وجهتين",
    publishingTo_few: "النشر إلى {{formattedCount}} وجهات",
    publishingTo_many: "النشر إلى {{formattedCount}} وجهة",
    publishingTo_other: "النشر إلى {{formattedCount}} وجهة",
    configureToPublish: "قم بإعداد وجهة تيليجرام للنشر",
  },
  actions: {
    approve: "موافقة",
    publish: "نشر",
    publishing: "جارٍ النشر",
    archive: "أرشفة",
    restore: "استعادة",
    sync: "مزامنة المصادر",
    syncing: "جارٍ المزامنة",
  },
  search: {
    label: "البحث في المنشورات أو القنوات",
    placeholder: "البحث في المنشورات أو القنوات",
  },
  empty: {
    title: "لا توجد منشورات بحالة «{{status}}»",
    search: "لا توجد منشورات مطابقة لهذا البحث. جرّب قناة أو عبارة أخرى.",
    default: "زامن قنوات المصدر لجمع محتوى تيليجرام جديد.",
  },
  queue: {
    title: "قائمة المنشورات",
    count: "{{formattedCount}} · {{status}}",
    mediaPost: "منشور وسائط",
  },
  mobile: {
    reviewPost: "مراجعة المنشور",
    back: "العودة إلى قائمة المنشورات",
    position: "{{current}} من {{total}}",
    steps: {
      review: "مراجعة",
      approve: "موافقة",
      publish: "نشر",
    },
    modeLabel: "وضع المراجعة",
    modes: {
      original: "الأصل",
      edit: "تحرير",
      preview: "معاينة",
    },
  },
  accessibility: {
    originalPost: "المنشور الأصلي",
    postStatus: "حالة المنشور",
    toolkit: "أدوات تنسيق المحتوى بالذكاء الاصطناعي",
    curatedVersion: "النسخة المنسقة",
    postQueue: "قائمة المنشورات",
    curatedEditor: "محرر المنشور المنسق",
    mobilePostList: "قائمة المنشورات على الهاتف",
    reviewPost: "مراجعة المنشور",
  },
} as const;

export default inbox;
